import Hero from './components/Hero';
import Services from './components/Services';
import OurWork from './components/OurWork';
import QuickQuote from './components/QuickQuote';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'HVACBusiness',
  name: 'KC24Coolingandheating',
  description:
    'Professional heating and cooling services in Kansas City. 24/7 emergency HVAC repair, AC installation, furnace maintenance, and annual service plans. Licensed & insured with 15+ years experience.',
  url: siteUrl,
  telephone: '(816) 555-1234',
  image: `${siteUrl}/og-image.jpg`,
  priceRange: '$$',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Kansas City',
    addressRegion: 'MO',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 39.0997,
    longitude: -94.5786,
  },
  areaServed: {
    '@type': 'City',
    name: 'Kansas City',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '00:00',
      closes: '23:59',
    },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'HVAC Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AC Installation' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Furnace Repair' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'HVAC Maintenance' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '24/7 Emergency HVAC Repair' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Duct Cleaning' } },
    ],
  },
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'KC24Coolingandheating',
  url: siteUrl,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'Do you offer 24/7 emergency HVAC repair in Kansas City?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, KC24Coolingandheating provides 24/7 emergency HVAC repair services throughout the Kansas City area. Call us anytime at (816) 555-1234.',
      },
    },
    {
      '@type': 'Question',
      name: 'What HVAC services do you provide in Kansas City?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We offer a full range of heating and cooling services including AC installation, furnace repair, HVAC maintenance, duct cleaning, and emergency repair services across Kansas City.',
      },
    },
    {
      '@type': 'Question',
      name: 'Are you licensed and insured for HVAC work in Missouri?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, KC24Coolingandheating is fully licensed and insured in Missouri with over 15 years of experience providing professional heating and cooling services.',
      },
    },
    {
      '@type': 'Question',
      name: 'How quickly can you respond to an HVAC emergency in Kansas City?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We offer fast-response emergency HVAC services throughout Kansas City, often arriving within 1–2 hours of your call, any time of day or night.',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navigation />
      <Hero />
      <Services />
      <OurWork />
      <QuickQuote />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
}
